// extracted by mini-css-extract-plugin
export var addAttachmentButton = "TicketDetailPage-module__addAttachmentButton___FAHG9";
export var addAttachmentButtonDisabled = "TicketDetailPage-module__addAttachmentButtonDisabled___bA24-";
export var addAttachmentField = "TicketDetailPage-module__addAttachmentField___FLF6C";
export var addAttachmentInput = "TicketDetailPage-module__addAttachmentInput___LMrAY";
export var addAttachmentRow = "TicketDetailPage-module__addAttachmentRow___AnPP8";
export var addTagInput = "TicketDetailPage-module__addTagInput___cMZHm";
export var attachmentDesc = "TicketDetailPage-module__attachmentDesc___uFTPI";
export var attachmentInfo = "TicketDetailPage-module__attachmentInfo___wAA9D";
export var attachmentItem = "TicketDetailPage-module__attachmentItem___k4h8c";
export var attachmentLink = "TicketDetailPage-module__attachmentLink___0bz8F";
export var attachmentList = "TicketDetailPage-module__attachmentList___PZPVQ";
export var attachmentRemove = "TicketDetailPage-module__attachmentRemove___n4UPI";
export var attachmentsSection = "TicketDetailPage-module__attachmentsSection___ISOJ+";
export var charCount = "TicketDetailPage-module__charCount___FFoQ+";
export var charCountWarning = "TicketDetailPage-module__charCountWarning___vHYJI";
export var closeTicketButton = "TicketDetailPage-module__closeTicketButton___OcBvd";
export var commentAdmin = "TicketDetailPage-module__commentAdmin___9NJUo";
export var commentBubble = "TicketDetailPage-module__commentBubble___uqe5k";
export var commentHtml = "TicketDetailPage-module__commentHtml___4r7Ej";
export var commentInput = "TicketDetailPage-module__commentInput___fzl5T";
export var commentMeta = "TicketDetailPage-module__commentMeta___GoX5h";
export var commentOtherUser = "TicketDetailPage-module__commentOtherUser___iSN2j";
export var commentRichTextEditor = "TicketDetailPage-module__commentRichTextEditor___Ow2wD";
export var commentSendButton = "TicketDetailPage-module__commentSendButton___J+DY+";
export var commentText = "TicketDetailPage-module__commentText___QWeXO";
export var commentUser = "TicketDetailPage-module__commentUser___KM+ls";
export var commentsList = "TicketDetailPage-module__commentsList___NUVCw";
export var commentsSection = "TicketDetailPage-module__commentsSection___-GLRC";
export var descriptionHtml = "TicketDetailPage-module__descriptionHtml___nlcLl";
export var descriptionSection = "TicketDetailPage-module__descriptionSection___jFZx9";
export var descriptionText = "TicketDetailPage-module__descriptionText___YsZn-";
export var emptyMessage = "TicketDetailPage-module__emptyMessage___ZQa0S";
export var fadeSlideIn = "TicketDetailPage-module__fadeSlideIn___plU-0";
export var infoBox = "TicketDetailPage-module__infoBox___0MEQt";
export var infoItem = "TicketDetailPage-module__infoItem___s35bO";
export var infoLabel = "TicketDetailPage-module__infoLabel___HEAXt";
export var infoValue = "TicketDetailPage-module__infoValue___BAWR0";
export var loadingContainer = "TicketDetailPage-module__loadingContainer___rq225";
export var modalBody = "TicketDetailPage-module__modalBody___p-bRT";
export var modalHeader = "TicketDetailPage-module__modalHeader___0P0o1";
export var modalHeaderTitle = "TicketDetailPage-module__modalHeaderTitle___50qiz";
export var modalHeaderTitleRow = "TicketDetailPage-module__modalHeaderTitleRow___ksj7X";
export var saveAttachmentsButton = "TicketDetailPage-module__saveAttachmentsButton___kRcIN";
export var saveTagsButton = "TicketDetailPage-module__saveTagsButton___yGlBz";
export var sectionTitle = "TicketDetailPage-module__sectionTitle___7CmOx";
export var statusRow = "TicketDetailPage-module__statusRow___2DiiT";
export var tag = "TicketDetailPage-module__tag___dPQ6l";
export var tagRemove = "TicketDetailPage-module__tagRemove___rDQ7F";
export var tagsList = "TicketDetailPage-module__tagsList___QyFeW";
export var tagsSection = "TicketDetailPage-module__tagsSection___WN2o-";
export var teamScopeBadge = "TicketDetailPage-module__teamScopeBadge___IsuwH";
export var teamScopeHelp = "TicketDetailPage-module__teamScopeHelp___nTILw";
export var teamScopeLabel = "TicketDetailPage-module__teamScopeLabel___ZTLjO";
export var teamScopeRow = "TicketDetailPage-module__teamScopeRow___D6Qqx";
export var teamScopeSaveButton = "TicketDetailPage-module__teamScopeSaveButton___pblxP";
export var teamScopeSection = "TicketDetailPage-module__teamScopeSection___NUxSX";
export var teamScopeSelect = "TicketDetailPage-module__teamScopeSelect___k296p";
export var ticketNumber = "TicketDetailPage-module__ticketNumber___Xdb75";
export var translationBadge = "TicketDetailPage-module__translationBadge___9H6fr";
export var translationBadgeGroup = "TicketDetailPage-module__translationBadgeGroup___Nd9Az";
export var translationToggle = "TicketDetailPage-module__translationToggle___FeWrw";
export var undoButton = "TicketDetailPage-module__undoButton___xRvXa";
export var undoItem = "TicketDetailPage-module__undoItem___LTxLU";
export var undoList = "TicketDetailPage-module__undoList___YbLeT";
export var undoText = "TicketDetailPage-module__undoText___7TYNE";